import { revenueTooltipHandler } from "components/pages/dashboard/revenue_analytic/chart/revenueTooltip";

const useRevenueChart = (data) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      tooltip: {
        enabled: false,
        position: "nearest",
        external: revenueTooltipHandler,
      },
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Amount in $",
        },
      },
    },
  };

  const chartData = {
    labels: data?.labels,
    datasets: [
      {
        data: data?.total,
        percentage: data?.percentage,
        borderColor: "#5489D8",
        backgroundColor: "#5489D8",
        barThickness: 10,
      },
    ],
  };

  return { options, chartData };
};

export default useRevenueChart;
